module.exports = __webpack_public_path__ + "img/xiandanmall.67594044.png";